/*
 *
 * TreatmentFlow constants
 *
 */
export const scope = "app/TreatmentFlow/";

export const DEFAULT_ACTION = `${scope}DEFAULT_ACTION`;

export const GET_PRODUCT_TYPES = "app/TreatmentFlow/GET_PRODUCT_TYPES";
export const GET_PRODUCT_TYPES_SUCCESS =
  "app/TreatmentFlow/GET_PRODUCT_TYPES_SUCCESS";
export const GET_PRODUCT_TYPES_ERROR =
  "app/TreatmentFlow/GET_PRODUCT_TYPES_ERROR";

export const GET_CONFIGURATION = "app/TreatmentFlow/GET_CONFIGURATION";

export const GET_ACTIVE_PRODUCT_PLAN =
  "app/TreatmentFlow/GET_ACTIVE_PRODUCT_PLAN";
export const GET_ACTIVE_PRODUCT_PLAN_SUCCESS =
  "app/TreatmentFlow/GET_ACTIVE_PRODUCT_PLAN_SUCCESS";
export const GET_ACTIVE_PRODUCT_PLAN_ERROR =
  "app/TreatmentFlow/GET_ACTIVE_PRODUCT_PLAN_ERROR";

export const CREATE_ACTION_PLAN = "app/TreatmentFlow/CREATE_ACTION_PLAN";
export const CREATE_ACTION_PLAN_SUCCESS =
  "app/TreatmentFlow/CREATE_ACTION_PLAN_SUCCESS";
export const CREATE_ACTION_PLAN_ERROR =
  "app/TreatmentFlow/CREATE_ACTION_PLAN_ERROR";

export const GET_PRODUCT_CONFIGURATION =
  "app/TreatmentFlow/GET_PRODUCT_CONFIGURATION";
export const GET_PRODUCT_CONFIGURATION_SUCCESS =
  "app/TreatmentFlow/GET_PRODUCT_CONFIGURATION_SUCCESS";
export const GET_PRODUCT_CONFIGURATION_ERROR =
  "app/TreatmentFlow/GET_PRODUCT_CONFIGURATION_ERROR";

export const RESET = "app/TreatmentFlow/RESET";
